import classNames from 'classnames';
import { t } from 'ttag';

import { useViewedProducts } from '@hook/useViewedProducts';
import { Title } from '@ui/Title';
import { ViewedProductsContainer } from '@containers/ViewedProducts';

import s from './ProductDetailsViewedProducts.sss';

interface Props {
  className?: string,
  productId: number,
}

export const ProductDetailsViewedProducts: React.FC<Props> = ({
  className,
  productId,
}) => {
  const { viewedProductsIds } = useViewedProducts({
    excludeProductIds: [productId],
  });

  if (viewedProductsIds.length) {
    return (
      <div className={classNames(s.root, className)}>
        <Title
          className={s.title}
          type="h3"
          bold={false}
        >
          {t`Ви також переглядали`}
        </Title>

        <ViewedProductsContainer excludeProductIds={[productId]} />
      </div>
    );
  }

  return null;
};
